import { Suspense } from 'react';
import { Page, Spinner, Box } from '@shopify/polaris';

/**
 * Loading fallback component for route-level Suspense
 * Shows a centered Polaris spinner while route chunks/data are loading
 */
export function RouteLoadingFallback() {
    return (
        <Page>
            <Box paddingBlockStart="1600">
                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '50vh' }}>
                    <Spinner accessibilityLabel="Loading page" size="large" />
                </div>
            </Box>
        </Page>
    );
}

/**
 * Wrapper component that provides Suspense boundary for lazy-loaded routes
 * @param {Object} props
 * @param {React.ReactNode} props.children - The lazy-loaded component
 * @param {React.ReactNode} [props.fallback] - Optional custom fallback component
 */
export default function RouteLoader({ children, fallback }) {
    return <Suspense fallback={fallback || <RouteLoadingFallback />}>{children}</Suspense>;
}
